import React from "react"
import CustomSelect from '../shared/CustomSelect'
import KeyDropdownValue from "../shared/KeyDropdownValue"
const CatalogOrderOptions = ({campaign, orderOptions, onOrderChange, selectedOrder}) => {
  return (
        <KeyDropdownValue
          name={"catalog-order-options-select"}
          isClearable
          title="Ordenar"
          onChange={onOrderChange}
          options={orderOptions}
          optionsLabel={'name'}
          optionsId={'id'}
          defaultValue={selectedOrder}
          placeholder="Ordenar por ..."
          noMessage={() => "Sem filtros"}
        />
  )
}

export default CatalogOrderOptions
